import { Button, Popover, Divider, Progress, Space } from "antd";
import styles from "./index.module.scss";
import React, { useMemo, useState } from "react";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { setIsOpen, setUserInfo, setAvatar } from "@/store/modules/user";
import profile from "@/assets/images/profile.png";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import CreateResource from '@/components/CreateResource';
import intl from "react-intl-universal";
import { useUploadQueue } from "@/contexts/uploadQueueContext";
import { announceOpenGaLogout } from "@/pages/openGA/authBridge";
const UserInfo = () => {
  const { userInfo } = useSelector((state) => state.user);
  const { avatar } = useSelector((state) => state.user);
  const roleId = useMemo(() => userInfo?.roleId, [userInfo]);
  const [modalOpen, setModalOpen] = useState(false);
  const {
    tasks,
    totalPercent,
    activeCount,
    pausedCount,
    errorCount,
    retryUpload,
    pauseUpload,
    resumeUpload,
    cancelUpload,
    clearFinished,
  } = useUploadQueue();
  const dispatch = useDispatch();
  const nickname = useMemo(() => userInfo?.nickname, [userInfo]);
  const email = useMemo(() => userInfo?.email, [userInfo]);
  const navigate = useNavigate();
  // 登录方法
  const handleLogin = () => {
    dispatch(setIsOpen(true));
  };
  // 跳转到个人中心
  const toLink = (url) => {
    navigate(url);
    window.scrollTo(0, 0);
  };

  //共享资源弹窗
  const showModal = () => {
    setModalOpen(true);
  };
  const uploadTasks = tasks.filter((task) => task.file && task.status !== "canceled");
  const hasUploadTasks = uploadTasks.length > 0;
  const shouldShowUploadProgress = activeCount > 0 || pausedCount > 0 || errorCount > 0;
  const uploadTitle =
    activeCount > 0
      ? `后台上传中 ${activeCount} 个`
      : pausedCount > 0
      ? `已暂停 ${pausedCount} 个`
      : errorCount > 0
      ? `上传失败 ${errorCount} 个`
      : "上传完成";
  const content = (
    <div>
      <div className={classNames(styles.profileBox)}>
        <img
          onClick={() => toLink("/personal")}
          src={
            avatar && avatar !== "undefined"
              ? process.env.REACT_APP_API_AFFIX +
                "/file/preview?filePath=" +
                avatar
              : profile
          }
        />
        <div>
          <div>{nickname}</div>
          <span>{email}</span>
        </div>
      </div>
      {hasUploadTasks && (
        <>
          <Divider />
          <div className={styles.uploadPanel}>
            <div className={styles.uploadHeader}>
              <span>{uploadTitle}</span>
              {activeCount === 0 && pausedCount === 0 && errorCount === 0 && (
                <Button size="small" type="link" onClick={clearFinished}>
                  清除
                </Button>
              )}
            </div>
            {shouldShowUploadProgress && (
              <Progress
                size="small"
                percent={totalPercent}
                status={errorCount > 0 ? "exception" : "active"}
              />
            )}
            <div className={styles.uploadList}>
              {uploadTasks.slice(0, 5).map((task) => (
                <div className={styles.uploadItem} key={task.id}>
                  <span title={task.fileRelativePath || task.fileName}>
                    {task.fileRelativePath || task.fileName}
                  </span>
                  {task.status === "error" ? (
                    <Space size={0}>
                      <Button size="small" type="link" onClick={() => retryUpload(task.id)}>
                        重试
                      </Button>
                      <Button size="small" type="link" onClick={() => cancelUpload(task.id)}>
                        取消
                      </Button>
                    </Space>
                  ) : task.status === "paused" ? (
                    <Space size={0}>
                      <Button size="small" type="link" onClick={() => resumeUpload(task.id)}>
                        继续
                      </Button>
                      <Button size="small" type="link" onClick={() => cancelUpload(task.id)}>
                        取消
                      </Button>
                    </Space>
                  ) : ["queued", "hashing", "uploading"].includes(task.status) ? (
                    <Space size={0}>
                      <Button size="small" type="link" onClick={() => pauseUpload(task.id)}>
                        暂停
                      </Button>
                      <Button size="small" type="link" onClick={() => cancelUpload(task.id)}>
                        取消
                      </Button>
                    </Space>
                  ) : (
                    <i>{task.status === "hashing" ? "解析中" : `${task.percent || 0}%`}</i>
                  )}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      <Divider />
      <div
        className={classNames(
          "flex_box",
          "flex_between",
          "align_center",
          styles.logout
        )}
      >
        <div>
          <Button type="primary" size="small" onClick={showModal}>
            {intl.get("User.Share")}
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              toLink("/discover/my-share");
            }}
          >
            {intl.get("User.My Share")}
          </Button>

          {Number(roleId) === 3 && (
            <Button
              type="primary"
              size="small"
              onClick={() => {
                toLink("/discover/my-course");
              }}
            >
              {intl.get("User.My courses")}
            </Button>
          )}
        </div>
        <Button
          icon={<LogoutOutlined />}
          onClick={() => {
            announceOpenGaLogout();
            window.setTimeout(() => {
              dispatch(
                setUserInfo({
                  username: "",
                  token: "",
                  refreshToken: "",
                  roleId: "",
                  password: "",
                  nickname: "",
                  uuid:""
                })
              );
              dispatch(setAvatar(""));
              localStorage.clear();
              navigate("/");
            }, 50);
          }}
          size="small"
        >
          {intl.get("User.Sign out")}
        </Button>
      </div>
    </div>
  );
  return (
    <div className={classNames(styles.tokenBox)}>
      {!nickname && (
        <Button type="primary" onClick={handleLogin}>
          {intl.get("User.Sign in")}
        </Button>
      )}
      {nickname && (
        <Popover content={content}>
          <div>
            <div
              className={classNames(
                "flex_box",
                "align_center",
                "flex_end",
                styles.userBox
              )}
            >
              <img
                src={
                  avatar && avatar !== "undefined"
                    ? process.env.REACT_APP_API_AFFIX +
                      "/file/preview?filePath=" +
                      avatar
                    : profile
                }
                className={classNames(styles.imgBox)}
              />
              <span>{nickname}</span>
            </div>
            {shouldShowUploadProgress && (
              <div className={styles.uploadMini}>
                <Progress
                  size="small"
                  showInfo={false}
                  percent={totalPercent}
                  status={errorCount > 0 ? "exception" : "active"}
                />
              </div>
            )}
          </div>
        </Popover>
      )}
      <CreateResource setModalOpen={setModalOpen} modalOpen={modalOpen} />
    </div>
  );
};
export default UserInfo;
